import fetchDataService from "./fetchDataService"

/**
 * Mutaciones del módulo WPBOT (POST cifrados al backend :5006).
 *
 * Manejo de respuestas del backend: status 200 = ok, 220 = error de negocio,
 * 230 = error interno (el proxy responde HTTP 220/230 con el body cifrado,
 * que fetchDataService descifra; aquí solo se inspecciona `status`).
 */
const api_request = async (requestPromise: Promise<any>, errorMessage: string) => {
  try {
    const response = await requestPromise;
    if (response?.error || (response?.status && response.status !== 200)) {
       throw new Error(response.message || response.error || errorMessage);
    }
    return response;
  } catch (err: any) {
    return { error: true, message: err.message || errorMessage };
  }
};

const post = (url: string, tokenData: any, requestData: any, errorMessage: string) =>
  api_request(
    fetchDataService.post(url, tokenData.key, {...requestData, csrfToken: tokenData?.token?.uid, session: tokenData?.session}),
    errorMessage
  )

// ── Bots ──
const createBot = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/create-bot', tokenData, requestData, "Error al crear el bot")
}

const updateBot = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/update-bot', tokenData, requestData, "Error al actualizar el bot")
}

const deleteBot = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/delete-bot', tokenData, requestData, "Error al eliminar el bot")
}

// ── Tools ──
const createTool = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/create-tool', tokenData, requestData, "Error al crear la herramienta")
}

const updateTool = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/update-tool', tokenData, requestData, "Error al actualizar la herramienta")
}

const deleteTool = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/delete-tool', tokenData, requestData, "Error al eliminar la herramienta")
}

const setToolEnabled = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/set-tool-enabled', tokenData, requestData, "Error al cambiar el estado de la herramienta")
}

// ── Contactos ──
const setContactBlocked = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/set-contact-blocked', tokenData, requestData, "Error al actualizar el contacto")
}

// ── Apps del bot ──
const setAppEnabled = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/set-app-enabled', tokenData, requestData, "Error al actualizar la aplicación del bot")
}

const generateSystemPrompt = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/generate-system-prompt', tokenData, requestData, "Error al generar el prompt del sistema")
}

const generateWelcomeMessages = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/generate-welcome-messages', tokenData, requestData, "Error al generar el saludo")
}

const updateCalendarCustomEvents = async (tokenData:any, requestData:any) => {
  return await post('/wpbot/update-calendar-custom-events', tokenData, requestData, "Error al guardar los servicios del calendario")
}

export default {
  createBot,
  updateBot,
  deleteBot,
  createTool,
  updateTool,
  deleteTool,
  setToolEnabled,
  setContactBlocked,
  setAppEnabled,
  generateSystemPrompt,
  generateWelcomeMessages,
  updateCalendarCustomEvents,
}
